import { createBenefitDetailsQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useBenefitDetailsQuery = createBenefitDetailsQuery(HTTP_CONFIG.API.Optimizely.url)
